/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */

import LineDataset from '@fusioncharts/charts/src/dataset/line';
import { __firePlotEvent, configurer, _updateImage, _drag } from '../dragarea';
import { pluckNumber } from '@fusioncharts/core/src/lib';
import { _restore, _getJSONData } from '../dragcolumn';
import { addDep } from '@fusioncharts/core/src/dependency-manager';
import draglineAnimation from './index.animation';

addDep({
  name: 'dragLineAnimation',
  type: 'animationRule',
  extension: draglineAnimation
});
/**
 * dataset class of dragcolumn inheriting from column class
 */
class DragLineDataset extends LineDataset {
  /**
   * Using fireplotevent of dragarea.
   */
  _firePlotEvent () {
    __firePlotEvent.apply(this, arguments);
  }

  /**
   * Function to update image while dragging.
   * @param {Object} dataObj The object by which the dataset is to be updated.
   */
  updateImage (dataObj) {
    _updateImage.call(this, dataObj);
  }

  /**
   * Function to manage drag over the datasets
   */
  drag () {
    _drag.apply(this, arguments);
  }

  /**
   * Calling the configureAttributes of drag area.
   */
  configureAttributes () {
    configurer.apply(this, arguments);
  }
  /**
   * method to configure a particular data plot object
   * @param {number} i index of the data object to be configured
   * @param {Object} setData particular plot information in of i'th index in input json
   */
  _plotConfigure (i, setData) {
    let conf = this.config,
      dataStore = this.components.data,
      dataObj,
      config;
    super._plotConfigure(i, setData);
    dataObj = dataStore[i];
    config = dataObj.config;
    config.allowDrag = pluckNumber(setData.allowdrag, conf.allowDrag);
    config.allowNegDrag = pluckNumber(setData.allownegativedrag, conf.allowNegDrag);
  }
  /**
   * Sets the type of the component
   * @return {string} type
   */
  getType () {
    return 'dataset';
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'dragLine';
  }
  /**
   * Function to restore the values of the dataset to its original
   */
  restore () {
    _restore.call(this);
  }

  /**
   * Fucntion to get the updated values of data when they are dragged.
   * @return {Object} The corresponding data Array of the dataset containing the values of all the sets.
   */
  getJSONData () {
    return _getJSONData.call(this);
  }
}
export default DragLineDataset;
